// The site footer — one footer, the same on every page.
//
// Owner, 2026-10-08: "I need all footers to match across the site. I don't
// really like the cow image… can we make it more professional with our logo."
// The sunrise photograph band is gone. The foot is the masthead's navy with
// the RaisedBeef mark, the DVAuction attribution, the legal row and the line.
// It is rendered by TickerShell and the homepage, so no page carries its own.
//
// Plain <a> throughout: the homepage is prerendered and mounts no Router.

// ⚠️ THE PRODUCT ROW IS OFF. Owner, 2026-10-07: "On the links in the
// footer…they are all wrong….take these links away for now." Put a product
// row back only when each destination is right.
//
// ⚠️ THE LEGAL ROW IS RAISEDBEEF.COM'S OWN (2026-10-10). On this host /privacy,
// /terms and /support render legal/RAISEDBEEF_*.md — the app's and the site's
// own documents, separate from the platform's (owner rule). The platform-only
// pages that used to sit here (Do Not Sell, Cookies, Acceptable Use, Community
// Guidelines, Disclaimer) describe the terminal and the Network, not this site:
// RaisedBeef.com sells no personal information, its cookies and its market-data
// disclaimer are in its own Privacy Policy and Terms (§3), and it has no
// member community.
import { siteHomeHref } from "@/lib/siteHost";

const LEGAL = [
  { label: "Privacy", href: "/privacy" },
  { label: "Terms", href: "/terms" },
  { label: "Support", href: "/support" },
  { label: "Delete Your Account", href: "/support#delete" },
];

export default function Footer() {
  return (
    <footer className="rbnext-foot">
      <div className="rbnext-foot-in">
        <div className="rbnext-foot-brand">
          <a className="rbnext-foot-mark" href={siteHomeHref()} aria-label="RaisedBeef home">
            <img src="/brand/rb-white.png" alt="RaisedBeef" width="140" height="56" />
          </a>
          <span className="rbnext-foot-pow">
            <span>Powered by</span>
            <img src="/brand/dv-mark.png" alt="DVAuction" width="106" height="20" />
            {/* Cattle Market Central only: "driven by DVAuction and RaisedBeef" (src/brand/). */}
            <span className="cmc-only rbnext-foot-and">and</span>
            <img className="cmc-only cmc-keep" src="/brand/rb-white.png" alt="and RaisedBeef" width="106" height="42" />
          </span>
        </div>

        <nav className="rbnext-foot-legal" aria-label="Legal">
          {LEGAL.map((l) => (
            <a key={l.href} href={l.href}>{l.label}</a>
          ))}
          {/* Reopens the ad-measurement question (src/lib/metaPixel.ts). Without
              JavaScript it is just a link to the privacy policy. */}
          <a href="/privacy" data-rb-ad-choices>Ad choices</a>
        </nav>

        <div className="rbnext-foot-meta">
          {/* Hardcoded rather than computed from the clock: this markup is
              prerendered, so a `new Date()` here would bake the build year into
              static HTML and go stale, and computing it at render time would be
              a hydration mismatch every New Year. */}
          <span>© 2026 RaisedBeef LLC</span>
          <span aria-hidden="true">·</span>
          <span>Live auction data from DVAuction · USDA market reports</span>
          <span aria-hidden="true">·</span>
          <a href="mailto:contact@raisedbeef.ai">contact@raisedbeef.ai</a>
        </div>
      </div>
    </footer>
  );
}
